export { default as ResetPassword } from "./Reset_password";
